import { useLocation } from 'react-router';
import { NAFGTMEvent } from '@appTypes/GTM/NAFGTMEvent';
import { EventPayload } from '@appTypes/GTM/EventPayload';
import { useGTMDataLayer } from '../../../hooks/GTM/useGTMDataLayer';
import { maskLicensePlateNumber } from '../../../hooks/VirtualPageViewTracking/maskLicensePlateNumber';

interface TrackElementClickProps {
  // e.g. 'card', 'accordion', 'dropdown'
  elementType: string;
  // Omit to let GTM pick up the closest text itself (keeps A/B tool text changes intact).
  linkText?: string;
  // Relative urls are resolved against the current origin.
  linkUrl?: string;
}

const toFullUrl = (url: string): string => {
  try {
    return new URL(url, window.location.origin).href;
  } catch {
    return url;
  }
};

export const useTrackElementClick = () => {
  const dataLayer = useGTMDataLayer();
  const location = useLocation();

  return ({ elementType, linkText, linkUrl }: TrackElementClickProps) => {
    const eventPayload: EventPayload = {
      event: NAFGTMEvent.elementClick,
      element_type: elementType,
      element_location: maskLicensePlateNumber(location.pathname),
      ...(linkText ? { link_text: linkText } : {}),
      ...(linkUrl ? { link_url: maskLicensePlateNumber(toFullUrl(linkUrl)) } : {}),
    };

    dataLayer?.push(eventPayload);
  };
};
